//
//
//
//
//
//
//
//
//
//
//

import ProcessPostList from "@/components/ProcessPostList";
import APIService from "@/services/APIService";
import axios from "axios"
import { sortByProperty } from "../util/common";

export default {
  name: "Manufacturer",
  components: {
    ProcessPostList
  },
  props: {
    profile: {
      type: Object,
      required: true
    },
    posts: {
      type: Object,
      required: true
    }
  },
  beforeRouteEnter(to, from, next) {
    axios.all([
      APIService.getProfile(to.params.id),
      APIService.getManufacturerPostsByManufacturer(to.params.id)
    ]).then((data) => {
      console.log("Profile", data[0], data[1])
      to.params.profile = data[0]
      to.params.posts =  data[1].sort(sortByProperty('title'))
      next()
    })
  }
}
